import {
  createContext,
  FC,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import AllergyList from "./AllergyList";
import { AllergyContextType, AllergyListType, normalizeAllergyItem } from "./types";
import { useMutation } from "react-query";
import { getAllergyData } from "../../services";
import { useParams } from "react-router-dom";
import usePopup from "../../../hooks/usePopup";

export const AllergyContext = createContext<AllergyContextType>({
  list: [],
  setList: () => {},
  edit: null,
  setEdit: () => {},
  success: false,
  setSuccess: () => {},
});

export const AllergyProvider: FC<PropsWithChildren> = ({ children }) => {
  const [list, setList] = useState<AllergyListType[]>([]);
  const { patientId } = useParams();
  const {showSnackbar} = usePopup()
  const [edit, setEdit] = useState<AllergyListType | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
    const { mutate: getAllergy } = useMutation(getAllergyData, {
      onSuccess: (data) => {
        if(data.responseIndicator == "success"){
          const allergies = data.response.flatMap((r: { data: AllergyListType[] }) =>
            r.data.map((item) => normalizeAllergyItem(item)),
          );
          setList(allergies);
          setSuccess(false)
        }else{
          showSnackbar({
             message:"Failed to fetch allergy details",
             open:true,
             variant:"warning",
             duration:3000
          })
        }
      },
      onError:()=>{
        showSnackbar({
          message:"Something went wrong !",
          open:true,
          variant:"warning",
          duration:3000
       })
      }
    });
  useEffect(() => {
    return () => {
      setList([]);
      setEdit(null);
    };
  }, []);
  useEffect(()=>{
      getAllergy(patientId as string)
  },[success])
  return (
    <AllergyContext.Provider
      value={{ list, setList, edit, setEdit, success, setSuccess }}
    >
      {children}
    </AllergyContext.Provider>
  );
};

const PatientAllergy: FC = () => {
  return (<AllergyList />);
};

export default PatientAllergy;
